// import Swiper JS
import Swiper from 'swiper';

export const imageSlider = () => {

	let imageSliderModules = document.querySelectorAll('.m__islider');
	if(imageSliderModules){
		
		imageSliderModules.forEach((imageSliderModule) => {

			let slideVideos 		= imageSliderModule.querySelectorAll('.js__islider-video');

			//Trigger the first video on page load
			if(slideVideos.length > 0){
				for (var source in slideVideos[0].children) {
				  var videoSource = slideVideos[0].children[source];
				  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				    videoSource.src = videoSource.dataset.src;
				  }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if(imageSliderModules.length >= 1){
				//Initialise the slider
				const iSwiper = new Swiper(imageSliderModule.querySelector('.m__islider__swiper-wrapper .swiper'), {
					centeredSlides : true,
					slidesPerView : 'auto',
					rewind : true,
					loop: true,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
				});

				if(iSwiper){
					iSwiper.slideTo(0,250);
				} 
			
				let isliderNextArrow 	= imageSliderModule.querySelector('.js__islider__swiper-next');
				let isliderPrevArrow 	= imageSliderModule.querySelector('.js__islider__swiper-prev');
			
				//Updates when a slide changes
				iSwiper.on('slideChange', function () {

					//Stop all videos from playing
					slideVideos.forEach((slideVideo) => {
						slideVideo.pause();
						slideVideo.currentTime = 0;
						slideVideo.load();
					})

					//Check for any videos on the slide and make sure they're lazy-loaded (Had a bug with intersection observer not being triggered due to how swiper loads items)
					let slideVideo = iSwiper.slides[iSwiper.activeIndex].querySelector("video"); 
					if(slideVideo){
						if(!slideVideo.currentTime > 0){ //Only reload video if it isn't already playing
							for (var source in slideVideo.children) {
							  var videoSource = slideVideo.children[source];
							  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							    videoSource.src = videoSource.dataset.src;
							  }
							}
							slideVideo.load();	
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							},1000);
						}
							          
					}

					// If not in loop mode hide next arrow if this is the last slide
					if (iSwiper && !iSwiper.params.loop) {
						if (iSwiper.isEnd) {
							isliderNextArrow.classList.add('hidden');
						} else {
							isliderNextArrow.classList.remove('hidden');
						}
					}

					// If not in loop mode hide prev arrow if this is the first slide
					if (iSwiper && !iSwiper.params.loop) {
						if (iSwiper.activeIndex == 0) {
							isliderPrevArrow.classList.add('hidden');
						} else {
							isliderPrevArrow.classList.remove('hidden');
						}
					}
				});


			
				//Move to next slide if 'prev' arrow clicked
				if(isliderPrevArrow){
					isliderPrevArrow.addEventListener('click', (event) => {
						let prevSlideIndex = (iSwiper.activeIndex > 0) ? (iSwiper.activeIndex - 1) : (iSwiper.slides.length - 1); 
						iSwiper.slideTo( prevSlideIndex );
					})
				}

				//Move to next slide if 'next' arrow clicked
				if(isliderNextArrow){
					isliderNextArrow.addEventListener('click', (event) => {
						let nextSlideIndex = (iSwiper.activeIndex < iSwiper.slides.length - 1) ? (iSwiper.activeIndex + 1) : 0; 
						iSwiper.slideTo( (nextSlideIndex) );
					})
				}
			}

		})
		
	}
}
